import {Button, Menu, Popover} from '@blueprintjs/core';
import {ReactElement, ReactNode} from 'react';

interface Props {
	children: ReactNode,
}

export default function ControlsMenu({children}: Props): ReactElement {
	return (
		<Popover
			content={(
				<Menu>
					{children}
				</Menu>
			)}
			placement="auto-start"
		>
			<Button icon="more" style={{rotate: '90deg'}} variant="minimal" size="small" />
		</Popover>
	);
}
